// 


import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { storage } from '../lib/storage'; // adjust the path

const ProtectedRoute = () => {
  const token = storage.getAccessToken();
  return token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
